import styled, { css } from 'styled-components';

import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';
import { variableFontRegular } from 'styles/theme/text';
import { IOffer } from 'shared/types/Offer';
import { LOCALES } from 'localization/constants/configEnums';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.buyBar.BuyBarSearchLayoutItemMobile';

interface IBuyBarSearchLayoutItemMobileProps {
  item?: IOffer;
  onClick: (...args: any[]) => void;
  locale?: LOCALES;
}

export const BuyBarSearchLayoutItemMobile = ({
  item,
  onClick,
  locale,
}: IBuyBarSearchLayoutItemMobileProps) => {
  const { price, size } = item;

  return (
    <BuyBarSearchLayoutItemMobile.Wrapper
      data-qa="buy_bar_item_mobile"
      onClick={() => onClick(size)}
    >
      <BuyBarSearchLayoutItemMobile.Size>{size}</BuyBarSearchLayoutItemMobile.Size>
      <BuyBarSearchLayoutItemMobile.Price
        price={Number(price) * 100}
        data-qa="buy_bar_size_price"
        locale={locale}
      />
    </BuyBarSearchLayoutItemMobile.Wrapper>
  );
};

export const BuyBarSearchLayoutItemMobileOneSize = ({
  item,
  onClick,
  locale,
}: IBuyBarSearchLayoutItemMobileProps) => {
  const { price, size } = item;

  return (
    <BuyBarSearchLayoutItemMobile.OneSize
      data-qa="buy_bar_item_mobile"
      onClick={() => onClick(size)}
    >
      <BuyBarSearchLayoutItemMobile.Size $isOneSizeLabel>
        {t(`${TP}.oneSize`, 'One Size')}
      </BuyBarSearchLayoutItemMobile.Size>
      <LocalizedCurrency price={Number(price) * 100} data-qa="buy_bar_size_price" locale={locale} />
    </BuyBarSearchLayoutItemMobile.OneSize>
  );
};

const buyBarBaseStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.black};
`;

BuyBarSearchLayoutItemMobile.OneSize = styled.div`
  ${buyBarBaseStyles}
  > div {
    width: 80px;
  }
`;

BuyBarSearchLayoutItemMobile.Wrapper = styled.div`
  ${buyBarBaseStyles}
`;

BuyBarSearchLayoutItemMobile.Size = styled.div<{ $isOneSizeLabel?: boolean }>`
  ${variableFontRegular({ height: '20px', size: '18px' })};
  margin-bottom: 4px;
  text-align: center;
  text-transform: ${({ $isOneSizeLabel }) => ($isOneSizeLabel ? 'capitalize' : 'uppercase')};
  white-space: nowrap;
`;

BuyBarSearchLayoutItemMobile.Price = styled(LocalizedCurrency)``;
